// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100..900&family=Lexend+Deca:wght@100..900&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.privacy_container {
  width: 47.5%;
  margin: 100px auto 0px;
  padding: 30px;
}

.privacy_section {
  margin-bottom: 20px;
}

.privacy_section:nth-child(1) {
  margin-bottom: 60px;
}

.privacy_section h1 {
  color: var(--color-text-gray);
  font-family: "Lexend Deca", sans-serif;
  text-align: center;
  font-size: 32px;
}

.privacy_section h2 {
  color: var(--color-text-gray);
  font-family: "Lexend Deca", sans-serif;
  font-size: 24px;
  margin-left: 10px;
}

.privacy_section p {
  color: var(--color-text-gray);
  line-height: 1.5;
  font-family: "Poppins", sans-serif;
  text-align: justify;
}

.privacy_section a {
  background-color: var(--color-blue-dark);
  text-decoration: none;
  display: block;
  padding: 10px 20px;
  border-radius: 8px;
  margin: 60px auto;
  width: max-content;
  font-family: "Poppins", sans-serif;
  font-weight: bolder;
  color: var(--color-white-main);
}

.privacy_section a:hover {
  background-color: var(--color-blue-circle);
}

.privacy_section img {
  display: block;
  margin: 60px auto;
  width: 64px;
  height: 64px;
}

@media only screen and (max-width: 600px) {
  .privacy_container {
    width: 90%;
    padding: 50px 0px 30px 0px;
    margin: -75px auto 0px;
  }
  .privacy_section h1 {
    font-size: 28px;
  }
}

@media only screen and (min-width: 601px) and (max-width: 1024px) {
  .privacy_container {
    width: 90%;
    padding: 50px 0px 30px 0px;
  }
  .privacy_section h1 {
    font-size: 28px;
  }
}

@media only screen and (min-width: 1025px) {
  .privacy_container {
    width: 60%;
  }
}


@media only screen and (min-width: 1600px) {
   .privacy_container {
      width: 48%;
    }
}`, "",{"version":3,"sources":["webpack://./src/views/policy/Policy.css"],"names":[],"mappings":"AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;;AAGA;GACG;MACG,UAAU;IACZ;AACJ","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@100..900&family=Lexend+Deca:wght@100..900&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n\n.privacy_container {\n  width: 47.5%;\n  margin: 100px auto 0px;\n  padding: 30px;\n}\n\n.privacy_section {\n  margin-bottom: 20px;\n}\n\n.privacy_section:nth-child(1) {\n  margin-bottom: 60px;\n}\n\n.privacy_section h1 {\n  color: var(--color-text-gray);\n  font-family: \"Lexend Deca\", sans-serif;\n  text-align: center;\n  font-size: 32px;\n}\n\n.privacy_section h2 {\n  color: var(--color-text-gray);\n  font-family: \"Lexend Deca\", sans-serif;\n  font-size: 24px;\n  margin-left: 10px;\n}\n\n.privacy_section p {\n  color: var(--color-text-gray);\n  line-height: 1.5;\n  font-family: \"Poppins\", sans-serif;\n  text-align: justify;\n}\n\n.privacy_section a {\n  background-color: var(--color-blue-dark);\n  text-decoration: none;\n  display: block;\n  padding: 10px 20px;\n  border-radius: 8px;\n  margin: 60px auto;\n  width: max-content;\n  font-family: \"Poppins\", sans-serif;\n  font-weight: bolder;\n  color: var(--color-white-main);\n}\n\n.privacy_section a:hover {\n  background-color: var(--color-blue-circle);\n}\n\n.privacy_section img {\n  display: block;\n  margin: 60px auto;\n  width: 64px;\n  height: 64px;\n}\n\n@media only screen and (max-width: 600px) {\n  .privacy_container {\n    width: 90%;\n    padding: 50px 0px 30px 0px;\n    margin: -75px auto 0px;\n  }\n  .privacy_section h1 {\n    font-size: 28px;\n  }\n}\n\n@media only screen and (min-width: 601px) and (max-width: 1024px) {\n  .privacy_container {\n    width: 90%;\n    padding: 50px 0px 30px 0px;\n  }\n  .privacy_section h1 {\n    font-size: 28px;\n  }\n}\n\n@media only screen and (min-width: 1025px) {\n  .privacy_container {\n    width: 60%;\n  }\n}\n\n\n@media only screen and (min-width: 1600px) {\n   .privacy_container {\n      width: 48%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
